import { gql } from "@apollo/client";

const GET_PRODUCTS = gql`
  query Products($params: GetProductLookUpParams) {
    products(params: $params) {
      items {
        productId
        productKey
        itemName
        itemDescription
        upcItemNumber
        glItemNumber
        glItemDescription
        categoryId
        categoryName
        categoryKey
        categoryDescription
        prices {
          productPriceId
          basePrice
          startDate
          endDate
        }
      }
      total
      page
      limit
    }
  }
`;

export default GET_PRODUCTS;
